const util = {  //  定义一个对象
  install (Vue, options) {  // 需要拥有一个 install 方法

  }
}
export default util



// WEBPACK FOOTER //
// ./src/util/util.js